<template>
	<div class="bg-white border rounded-lg p-4">
		<div class="flex justify-between items-start mb-4">
			<div>
				<h6 class="text-lg uppercase tracking-wider text-gray-500 mb-1">
					Discount volum
				</h6>
				<v-label class="text-base">
					Discount pe transe, aplicat la subtotalul comenzii. Pragurile sunt inlantuite:
					fiecare transa incepe de unde se termina cea anterioara.
				</v-label>
			</div>
			<v-btn @click="addTier" color="teal" outlined class="uppercase flex-grow-0">Adauga transa</v-btn>
		</div>

		<v-form v-model="validForm" ref="formVolumeTiers" @submit.prevent="save">
			<table class="w-full max-w-3xl mb-4">
				<thead>
					<tr class="text-left text-gray-500">
						<th class="pb-2 w-1/12">Transa</th>
						<th class="pb-2 w-3/12">De la (EUR)</th>
						<th class="pb-2 w-3/12">Pana la (EUR)</th>
						<th class="pb-2 w-3/12">Discount</th>
						<th class="pb-2 w-1/12"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(tier, index) in tiers" :key="index">
						<td class="py-1 align-middle">{{ index + 1 }}</td>
						<td class="py-1 pr-2 align-middle">
							<v-text-field :value="tierFrom(index)" dense type="number" outlined disabled suffix="eur"
								hide-details></v-text-field>
						</td>
						<td class="py-1 pr-2 align-middle">
							<v-text-field v-model="tier.to" dense type="number" min="0" step="100" hide-spin-buttons
								outlined suffix="eur" hide-details="auto"
								:rules="[rules.required, toRule(index)]"></v-text-field>
						</td>
						<td class="py-1 pr-2 align-middle">
							<v-text-field v-model="tier.rate" dense type="number" min="0" max="100" step="0.5"
								hide-spin-buttons outlined suffix="%" hide-details="auto"
								:rules="[rules.required, rules.percent]"></v-text-field>
						</td>
						<td class="py-1 align-middle text-right">
							<v-icon small :disabled="tiers.length < 2" @click="removeTier(index)">
								mdi-delete
							</v-icon>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="flex justify-end">
				<v-btn type="submit" color="teal" class="uppercase white--text" :loading="saving"
					:disabled="saving || !hasChanges">Salveaza</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import pricingSection from './pricingSection';

export default {
	name: "VolumeTiers",
	mixins: [pricingSection],
	data() {
		return {
			validForm: false,
			tiers: [],
			rules: {
				required: value => (value !== '' && value !== null && value !== undefined) || 'Câmp obligatoriu',
				percent: value => (!isNaN(parseFloat(value)) && parseFloat(value) >= 0 && parseFloat(value) <= 100) || 'Valoare intre 0 si 100',
			},
		};
	},
	computed: {
		saving() {
			return this.section.savingPricingConfig;
		},
		volumeTiers() {
			return this.section.pricingConfig.volumeTiers;
		},
		hasChanges() {
			const payload = this.buildPayload();

			if (payload.length != this.volumeTiers.length) return true;

			return payload.some((tier, index) => {
				const stored = this.volumeTiers[index];
				return tier.from !== stored.from || tier.to !== stored.to || tier.rate !== stored.rate;
			});
		}
	},
	methods: {
		// `from` is never edited directly, it always chains off the previous tier so no gaps can appear
		tierFrom(index) {
			return index == 0 ? 0 : Number(this.tiers[index - 1].to);
		},
		toRule(index) {
			return value => parseFloat(value) > this.tierFrom(index) || 'Trebuie sa fie mai mare ca "De la"';
		},
		syncFromStore() {
			this.tiers = this.volumeTiers.map(tier => ({
				to: tier.to,
				rate: Math.round((tier.rate || 0) * 10000) / 100
			}));
		},
		buildPayload() {
			return this.tiers.map((tier, index) => ({
				from: this.tierFrom(index),
				to: Number(tier.to),
				rate: Number((parseFloat(tier.rate) / 100).toFixed(4))
			}));
		},
		addTier() {
			const last = this.tiers[this.tiers.length - 1];
			const from = last ? Number(last.to) : 0;

			this.tiers.push({
				to: from + 5000,
				rate: last ? last.rate : 0
			});
		},
		removeTier(index) {
			this.tiers.splice(index, 1);
		},
		async save() {
			const valid = await this.$refs.formVolumeTiers.validate();

			if (valid) {
				// full replace of the column, the whole array is always sent
				this.dispatchSection('savePricingConfig', { volumeTiers: this.buildPayload() });
			}
		}
	},
	watch: {
		volumeTiers: {
			handler: 'syncFromStore',
			deep: true
		},
		// editing a `to` shifts the next tier's `from`, so the whole chain gets re-validated
		tiers: {
			handler() {
				this.$nextTick(() => {
					if (this.$refs.formVolumeTiers) this.$refs.formVolumeTiers.validate();
				});
			},
			deep: true
		}
	},
	created() {
		this.syncFromStore();
	}
};
</script>

<style scoped></style>
